enum TabOptions {
    All = 'All',
    Brand = 'Brands',
    Location = 'Breweries',
    Product = 'Brews',
}

export default TabOptions
